module.exports = __webpack_public_path__ + "static/jinhwanchoi-40b3ec5e74aad7c7c348e80dc534c9c0.jpeg";